import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getAutoAssignSearchingIds } from "../services/autoAssign";

export const useAutoAssignSearching = (entityIds: string[]) => {
  const sortedIds = useMemo(() => [...entityIds].sort(), [entityIds]);

  const query = useQuery({
    enabled: sortedIds.length > 0,
    queryFn: () => getAutoAssignSearchingIds(sortedIds),
    queryKey: ["auto-assign-searching", sortedIds],
    refetchOnWindowFocus: false,
    staleTime: 30 * 1000,
  });

  const searchingIds = useMemo(
    () => new Set(query.data?.entityIds ?? []),
    [query.data],
  );

  return { isLoading: query.isLoading, searchingIds };
};
